// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UQ0onjItmm8lhpAS8pmV{background:var(--background-primary-inverted-primary);cursor:pointer;border:1px solid transparent;border-radius:6px;align-items:center;height:24px;padding:4px 8px;display:inline-flex}.Fad7tjobLiw4lU9UwqUx{border:1px solid var(--action-contained-destructive-primary-normal)}.b9dt3sRrzZgcW6l5buLp{color:var(--content-negative-primary);margin-left:6px}.UQ0onjItmm8lhpAS8pmV:hover,.UQ0onjItmm8lhpAS8pmV.B19zaeWF7qcHSWv0IXQu{background:var(--background-neutral-subtle)}.UQ0onjItmm8lhpAS8pmV .WVuWoI3SsAnG6Gl1iv5E{margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `UQ0onjItmm8lhpAS8pmV`,
	"button__error": `Fad7tjobLiw4lU9UwqUx`,
	"buttonError": `Fad7tjobLiw4lU9UwqUx`,
	"button__iconError": `b9dt3sRrzZgcW6l5buLp`,
	"buttonIconError": `b9dt3sRrzZgcW6l5buLp`,
	"active": `B19zaeWF7qcHSWv0IXQu`,
	"chevron": `WVuWoI3SsAnG6Gl1iv5E`
};
export default ___CSS_LOADER_EXPORT___;
